import { Component, EventEmitter, Output } from '@angular/core';
import {SettingsService} from '../../services/settings.service'
import { TagService } from 'src/app/services/tag.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { PageEvent } from '@angular/material/paginator';
import { DataService } from 'src/app/services/data.service';
import { Route, Router,ActivatedRoute } from '@angular/router';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'

@Component({
  selector: 'app-tags-card',
  templateUrl: './tags-card.component.html',
  styleUrls: ['./tags-card.component.css']
})
export class TagsCardComponent {
  backClick(){

  }
  showAdd:boolean=false
  onClickNew(){
    this.tagsRequest={
        "tagName":"",
        "tagType":"",
        "description":"",
        "assignTag":false,
        "propertyValue":""
    }
    
    this.array=[]
    this.action='new'
this.showAdd=true
  }
  close(){
    this.showAdd=false

  }
  ngOnInit() {
    let data:any
    this.DataService.portMessage.subscribe((message:any) => {

      this.searchTags()

    })
    this.cardTypeList()

  }

  
array:any=[]
  Array(){
    let item:any={
      property:'',
      operator:'=',
      value:''
    }
this.array.push(item)
  }
  cancel(){
    this.array.splice(this.array.length-1, 1)
  }




  tagsRequest:any={
    "tagName":"",
    "tagType":"",
    "description":"",
    "assignTag":false,
    "propertyValue":""

  }
  
  tagList:any=[]
  pageStrCarrier:any={
    number:0,
    size:10
  }
  totalElements:any=0
  search:any={
    searchText:'',
    tagType:'CARD',
    tagName:'',
  }

    constructor(public SettingsService:SettingsService,private tagService:TagService,private PaymentConfigService:PaymentConfigService,
      private toastMsgService:ToastmsgService,private DataService:DataService,private router:Router){
  this.getTaglist({page:this.pageStrCarrier.number,size:this.pageStrCarrier.size})
    }
 
  
 
  showProfile:boolean=false
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  outputMessage:string="close";
  onClickProfile(data:any){
    this.showProfile=true
    this.DataService.deliverMsg(data)
  this.myOutput.emit(this.outputMessage);
  }
 

  saveCustomer() {
    this.tagsRequest.propertyValue=JSON.stringify(this.array)

    this.tagService.saveTag(this.tagsRequest)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Tag Added Successfully!",msgTitle : "Success", msgType : "I"});
            this.getTaglist({page:this.pageStrCarrier.number,size:this.pageStrCarrier.size})
            this.showAdd=false

          } else {
            const body : any = res.body;
            this.registerUserErrorMsg(res.status,body?.result);
          } 
        },error : (err) => {

          this.registerUserErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUserErrorMsg(status : number,msg : string) {
    if(status===400){
      this.toastMsgService.setMsg({msg :msg,msgTitle : "Warning", msgType : "W"});

    }else{
         this.toastMsgService.setMsg({msg : 'Failed to save',msgTitle : "Warning", msgType : "W"});
    }
  }
  searchTimeout:any
  
  searchTags(){
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getTaglist({page: this.pageStrCarrier.number, size: this.pageStrCarrier.size,})
    }, 300);
  }
  nextTagPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getTaglist(page)
  
  }
  getTaglist(page:any){

    this.tagService
    .getTagList(page,this.search)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pageStrCarrier.number=data.result['number']
            this.pageStrCarrier.size=data.result['size']
          }

          this.tagList=data.result.content;
          // console.log(this.customerList)
          this.totalElements = data.result['totalElements'];
        
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  
  action:any=''
 
  onEditClick(item:any){
    this.showAdd=true
    this.action='update'
    let tagsRequest:any={
      "tagName":item?.tagName,
      "tagType":item?.tagType,
      "description":item?.description,
      "propertyValue":JSON.parse(item?.propertyValue),
      "assignTag":item?.assignTag,
      "tagId":item?.tagId
    }
    this.array=tagsRequest.propertyValue

    this.tagsRequest=tagsRequest
  }
disabledSave:boolean=false
  UpdateTag() {
    this.disabledSave=true
    this.tagsRequest.propertyValue=JSON.stringify(this.array)||''
    this.tagService.saveTag(this.tagsRequest)
      .subscribe({
        next : (res) => {
          this.disabledSave=false
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Tag Updated Successfully!",msgTitle : "Success", msgType : "I"});
            this.getTaglist({page:this.pageStrCarrier.number,size:this.pageStrCarrier.size})
            this.showAdd=false

          } else {
            const body : any = res.body;
            this.registerUserUpdateErrorMsg(res.status,body?.result);
          } 
        },error : (err) => {
          this.disabledSave=false

          this.registerUserUpdateErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUserUpdateErrorMsg(status : number,msg : string) {
         this.toastMsgService.setMsg({msg : 'Failed to Update',msgTitle : "Warning", msgType : "W"});

  }
  
  disabled(): boolean {
    
    return !this.tagsRequest.tagType ||
           !this.tagsRequest.tagName ||
          
           this.disabledSave;
  }
tagsMapping:boolean=false
tagMapping:any={}
  onClickTagsmapping(id:any,tagType:any,tagName:any){

    let data:any={
      id:id,
      tagType:tagType,
      tagName:tagName
    }
    this.tagMapping=data
    this.DataService.deliverMsg(data)
    this.tagsMapping=true
    // this.router.navigate(["/app/Dashboard"]);
    

  }
  closeMapping(){
    this.tagsMapping=false
    this.DataService.deliverMsg('default message')

  }
  cardtypedata:any
  cardTypeList(){

    this.PaymentConfigService
    .cardtypeList()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.cardtypedata=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
}
